import { render, staticRenderFns } from "./invoice-purchase-red-add-or-update.vue?vue&type=template&id=682663ae&scoped=true"
import script from "./invoice-purchase-red-add-or-update.vue?vue&type=script&lang=js"
export * from "./invoice-purchase-red-add-or-update.vue?vue&type=script&lang=js"
import style0 from "./invoice-purchase-red-add-or-update.vue?vue&type=style&index=0&id=682663ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682663ae",
  null
  
)

export default component.exports